import { Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-inyova-grow-investment-box',
  templateUrl: './inyova-grow-investment-box.component.html',
  styleUrls: ['./inyova-grow-investment-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InyovaGrowInvestmentBoxComponent),
      multi: true
    }
  ],
  standalone: false
})
export class InyovaGrowInvestmentBoxComponent implements ControlValueAccessor {
  @Input() chips: number[];
  @Input() customAmount = false;
  @Input() hasError = false;
  @Input() title: string;
  @Input() savingsPlan = false;

  @ViewChild('inputEditable') inputEditable: ElementRef<HTMLInputElement>;

  value: number | string = '';
  showCustomInput = false;
  editMode = false;

  private onChange: (value: number | string) => void;
  private onTouched: () => void;

  writeValue(value: number): void {
    if (value !== null && value !== 0 && !this.chips.includes(value)) {
      this.showCustomInput = true;
    }
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onCheck(value: number) {
    this.showCustomInput = false;
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  onSelectCustomValue() {
    this.showCustomInput = true;
    this.editMode = true;
    this.value = '';
    this.onChange('');
    this.onTouched();
  }

  onInput(value) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  enterEditMode() {
    this.editMode = true;
    // wait for the input to be rendered, then focus
    setTimeout(() => {
      const el = this.inputEditable?.nativeElement;
      if (el) {
        el.focus();
      }
    });
  }
}
